import React, { useState, useEffect } from 'react';
import { useLocation } from "react-router-dom";
import HeaderMain from '../components/Home/Headers/HeaderMain';
import Footer from './Footer';
import FloatingDock from './FloatingDock';
import WhatsAppButton from './WhatsAppButton';

const Layout = ({ children, shoppingcart, quoteData  }) => {

    const location = useLocation();

    const hideNavbarRoutes = ["/branch/select/true", "/branch"];
    const shouldHideNavbar = hideNavbarRoutes.includes(location.pathname);

    return (
        <>
            <main className="ecommerce-wrapper ">
                {/* {!shouldHideNavbar && <HeaderMain />}  */}
                {/* {!shouldHideNavbar && <NavBar />}  */}
                <HeaderMain shoppingcart={shoppingcart} quoteData={quoteData}  />
                {children}
                {/* {!shouldHideNavbar &&  <WhatsAppButton message="Hola, quiero hacer una consulta" />} */}

                {/* <FloatingDock />  */}
                <Footer />
            </main>

        </>
    );
};

export default Layout;